import { useEffect, useState } from 'react';
import { getSelection } from '@/common/api/networkplan';
import { isArray } from '@lhb/func';

/**
 * @Description 初始化需要做的事情
 * 1.获取一级商圈数据
 * 2.获取屏幕宽度，且监听屏幕宽度
 * 3.获取后台配置的开关
 */
const InitEvent = () => {

  const [firstLevelCategory, setFirstLevelCategory] = useState<any>(null);// right（评分icon）、top(新增开店区域)使用
  const [isGreater1440, setIsGreater1440] = useState<boolean>(false);// 是否屏幕宽度大于1440--两个可以合并成一个
  const [isGreater1920, setIsGreater1920] = useState<boolean>(false);// 是否屏幕宽度大于1920--两个可以合并成一个

  // 获取一级商圈数据
  const getFirstLevelCategoryData = async () => {
    const data = await getSelection({ module: 2 });
    const { firstLevelCategory } = data || {};
    setFirstLevelCategory(isArray(firstLevelCategory) ? firstLevelCategory : []);
  };
  // 监听屏幕大小
  const changeSize = () => {
    const root = document.getElementById('root');
    const intiWidth = root?.offsetWidth as number;// 获取初始化的宽度
    const curWidth = root?.offsetWidth as number;// 获取当前的宽度
    setIsGreater1440(curWidth > 1440);
    setIsGreater1920(intiWidth > 1920);
  };


  useEffect(() => {
    getFirstLevelCategoryData();
  }, []);

  // 监听屏幕大小
  useEffect(() => {
    const root = document.getElementById('root');
    const intiWidth = root?.offsetWidth as number;// 获取初始化的宽度
    setIsGreater1440(intiWidth > 1440);
    setIsGreater1920(intiWidth > 1920);
    window.addEventListener('resize', changeSize);
    return () => {
      window.removeEventListener('resize', changeSize);
    };
  }, []);

  return {
    firstLevelCategory,
    isGreater1440,
    isGreater1920,
  };
};
export default InitEvent;
